export default "__VITE_ASSET__BXjyjkXU__"